import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { VrstaVozila } from './vrsta-vozila';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-vrsta-vozila-modal-update',
  templateUrl: './vrsta-vozila-modal-update.component.html'
})
export class VrstaVozilaModalUpdateComponent
extends BaseModalUpdateComponent<VrstaVozila> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaVozila>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
